<aku-header></aku-header>
<router-outlet></router-outlet>
<aku-footer></aku-footer>